import { createFileRoute } from '@tanstack/react-router'
import Groups from '../../../../../containers/groups'
import { groupsContextSearchSchema } from './search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/groups/'
)({
  validateSearch: groupsContextSearchSchema,
  component: Groups
})
